import { defineMessages } from 'react-intl-next';

export const inlineOnboardingMessages = defineMessages({
	howToUseThesePagesWithinJira: {
		id: 'project-pages.inline-onboarding.how-to-use-these-pages-within-jira',
		defaultMessage: 'How to use these pages with Jira',
		description: 'How to use these pages with Jira',
	},
	task1: {
		id: 'project-pages.inline-onboarding.task1',
		defaultMessage: 'to view a list of ways you can display Jira work on this page',
		description: 'description of how to use Jira with confluence',
	},
	task2: {
		id: 'project-pages.inline-onboarding.task2',
		defaultMessage:
			'Paste a Jira task or project link - the updates you make in Jira will automatically show',
		description: 'description of how jira updates will show in confluence',
	},
	task3: {
		id: 'project-pages.inline-onboarding.task3',
		defaultMessage:
			'to open a list of cool things to add, like a table to contents, dates, roadmaps, and more',
		description: 'description of how to add cool things to the page',
	},
	type: {
		id: 'project-pages.inline-onboarding.type',
		defaultMessage: 'Type',
		description: 'Type',
	},
	jira: {
		id: 'project-pages.inline-onboarding.jira',
		defaultMessage: 'Jira',
		description: 'Jira',
	},
});
